export default __webpack_public_path__ + "static/media/README.96ecc510.md";